module.exports = __webpack_public_path__ + "img/nosotros_16-9_2880.ffb595dd.webp";